<div class="tw-reset">
  <dgx-automation-value-lookup
    #triggerInput
    [resourceType]="resourceTypeForTrigger"
    [orgId]="orgId()"
    (onSelection)="setTriggerSecondaryValue($event)"
    (onRemove)="setTriggerSecondaryValue(null)"
    [selectedItem]="
      trigger()?.displayResourceValue
        ? {
            name: trigger().displayResourceValue,
            resourceId: trigger().resourceValue,
          }
        : null
    "
    [placeholderText]="resourceFieldName"
    [isRequired]="true"
    [compType]="compType"
  ></dgx-automation-value-lookup>
  @if (isInvalid()) {
    <div role="alert" class="tw-mt-1 tw-text-sm tw-text-danger-800">
      {{ i18nShared.Core_FieldRequired }}
    </div>
  }
</div>

<dgx-trigger-back-cancel-save-buttons
  [i18n]="i18nShared"
  [isSaving]="isSaving()"
  (clearTrigger)="onBack()"
  (saveEmitter)="onSave()"
  (cancelEmitter)="onCancel()"
  (backEmitter)="onBack()"
></dgx-trigger-back-cancel-save-buttons>
